import { render, staticRenderFns } from "./expertise.vue?vue&type=template&id=9efe9ba8&scoped=true"
import script from "./expertise.vue?vue&type=script&lang=js"
export * from "./expertise.vue?vue&type=script&lang=js"
import style0 from "./expertise.vue?vue&type=style&index=0&id=9efe9ba8&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9efe9ba8",
  null
  
)

export default component.exports